import * as React from 'react';
import PropTypes from "prop-types";
import {
  Grid,
  Table, TableBody, TableContainer, TableRow
} from "@mui/material";
import {RecipeIngredientTableCell} from "./RecipeTableCell";
import {getUnitLabel} from "../shared/Units";
import {formatDollarDecimal, toFixedDecimal} from "../utils/NumberUtils";

// Header row suports an array of 3 fields
function RecipeIngredientCostTable(props) {
  const {italicize, ingredientList, includeTotalRow} = props
  let generateTotals = includeTotalRow
  if (generateTotals === undefined) {
    generateTotals =  true
  }
  const font_style = italicize ? 'italic' : 'normal'

  function renderHeaderRow(type, unitFieldLabel, totalFieldLabel) {
    return (
      <TableRow sx={{fontStyle: font_style}} key={type}>
        <RecipeIngredientTableCell>{type}</RecipeIngredientTableCell>
        <RecipeIngredientTableCell align={'right'}>{unitFieldLabel}</RecipeIngredientTableCell>
        <RecipeIngredientTableCell align={'right'}>{totalFieldLabel}</RecipeIngredientTableCell>
      </TableRow>
    )
  }

  //
  // ingredient: {"type": ingredientType, "name": name, "priceAmount": 0.00, "priceUnit": unit, "costTotal": 0.00, "costPerUnit": 0.00}
  function renderRow(ingredient, ix) {
    let pricePerUnitDisplay = formatDollarDecimal(toFixedDecimal(ingredient.priceAmount, 2))
    pricePerUnitDisplay = `(${pricePerUnitDisplay} / ${getUnitLabel(ingredient.priceUnit)})`;

    return (
      <TableRow sx={{fontStyle: font_style}} key={`${ingredient.name}.${ix}`}>
        <RecipeIngredientTableCell>{ingredient.name} {pricePerUnitDisplay}</RecipeIngredientTableCell>
        <RecipeIngredientTableCell align={'right'}>{formatDollarDecimal(ingredient.costPerUnit)}</RecipeIngredientTableCell>
        <RecipeIngredientTableCell align={'right'}>{formatDollarDecimal(ingredient.costTotal)}</RecipeIngredientTableCell>
      </TableRow>
    )
  }

  function renderTotalRow(ingredientList) {
    if (generateTotals && ingredientList.length > 1) {
      let sumCostTotal = 0
      let sumCostPerUnit = 0
      ingredientList.forEach(ig => {
        sumCostTotal += ig.costTotal
        sumCostPerUnit += ig.costPerUnit
      })
      return (
        <TableRow sx={{fontStyle: font_style}} key={'Total'}>
          <RecipeIngredientTableCell>Total</RecipeIngredientTableCell>
          <RecipeIngredientTableCell align={'right'}>{formatDollarDecimal(toFixedDecimal(sumCostPerUnit, 2))}</RecipeIngredientTableCell>
          <RecipeIngredientTableCell align={'right'}>{formatDollarDecimal(toFixedDecimal(sumCostTotal, 2))}</RecipeIngredientTableCell>
        </TableRow>
      )
    } else {
      return null
    }
  }

  return (
    <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 12}}>
      <Grid item xs={3.5} sm={5} md={6}>
      <TableContainer>
        <Table size={"small"}>
        <TableBody>
          {
            renderHeaderRow('', 'Unit', 'Total')
          }
          {
            ingredientList.map((ig, ix) => (
              renderRow(ig, ix)
            ))
          }
          {
            renderTotalRow(ingredientList)
          }
        </TableBody>
        </Table>
      </TableContainer>
      </Grid>
    </Grid>
    )
}

RecipeIngredientCostTable.propTypes = {
  ingredientList: PropTypes.arrayOf(PropTypes.shape({
    percent: PropTypes.number,
    name: PropTypes.string,
    altUnitAmount: PropTypes.number,
    altUnit: PropTypes.string,
    weight: PropTypes.number,
    unit: PropTypes.string
  }))
}

export { RecipeIngredientCostTable }